import { MainNavComponent } from "./components/main-nav/main-nav.component";
import { Routes, RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/compiler/src/core";
import { InicioComponent } from "./components/inicio/inicio.component";
import { PresentacionComponent } from "./components/presentacion/presentacion.component";
import { NgModule } from "@angular/core";
import { Busqueda_dirComponent } from './components/totem/busqueda_dir/busqueda_dir.component';
import { SolicitudViviendaComponent } from "./components/solicitud-vivienda/solicitud-vivienda.component";
import { AuxCertSinPComponent } from "./components/aux-cert-sin-p/aux-cert-sin-p.component";
import { SolicitudViviendaXNumComponent } from "./components/solicitud-vivienda-x-num/solicitud-vivienda-x-num.component";
import { auxUrlDocsComponent } from "./components/auxUrlDocs/auxUrlDocs.component";
import { PreguntasComponent } from "./components/preguntas/preguntas.component";
import { ContactosComponent } from "./components/contactos/contactos.component";
import { SeguimientoCertificadosComponent } from "./components/seguimiento-certificados/seguimiento-certificados.component";
import { SeguimientoExpedienteComponent } from "./components/seguimiento-expediente/seguimiento-expediente.component";

const appRoutes: Routes = [
  { path: '', component: InicioComponent },
  // { path: "", component: PresentacionComponent },
  { path: "activate/:token", component: InicioComponent },
  { path: "expedientes", component: MainNavComponent },
  { path: "preguntas", component: PreguntasComponent },
  { path: "contactos", component: ContactosComponent },
  {
    path: "bnup",
    loadChildren: () =>
      import("src/app/components/bnup/bnup.module").then((m) => m.BnupModule),
  },
  {
    path: "certificados",
    loadChildren: () =>
      import("src/app/components/solicitud_certificados/solicitud_certificados.module").then((m) => m.SolicitudCertificadosModule),
  },

  {
    path: "seguimiento_certificados_pagos",
    loadChildren: () =>
      import("src/app/components/seg-cert-prov/seg-cert-prov.module").then((m) => m.SegCertProvModule),
  },

  {
    path: "inspeccion",
    loadChildren: () =>
      import("src/app/components/inspeccion/inspeccion.module").then(
        (m) => m.InspeccionModule
      ),
  },


  {
    path: "cert",
    loadChildren: () =>
      import("./components/certificados/certificados.routing").then(
        (m) => m.CertificadosRoutingModule
      ),
  },

  {
    path: "inicio",
    loadChildren: () =>
      import("./components/inicio/inicio.routing").then(
        (m) => m.InicioRoutingModule
      ),
  },
  {
    path: "borradores",
    loadChildren: () =>
      import("./components/borradores/borradores.module").then(
        (m) => m.BorradoresModule
      ),
  },
  {
    path: "formulario",
    loadChildren: () =>
      import("./components/formulario/formulario.routing").then(
        (m) => m.FormularioRoutingModule
      ),
  },
  {
    path: "home",
    loadChildren: () =>
      import("./components/home/home.routing").then((m) => m.HomeRoutingModule),
  },

  {
    path: "menu",
    loadChildren: () =>
      import("./components/menu/menu.routing").then((m) => m.MenuRoutingModule),
  },

  {
    path: "instructions",
    loadChildren: () =>
      import("./components/instructions/instructions.module").then(
        (m) => m.InstructionsModule
      ),
  },

  {
    path: "ventanasUrl",
    loadChildren: () =>
      import("./components/ventanasUrl/ventanasUrl.module").then(
        (m) => m.ventanasUrlModule
      ),
  },
  {
    path: "tramites",
    loadChildren: () =>
      import("./components/tramites/tramites.module").then(
        (m) => m.TramitesModule
      ),
  },
  { path: "seguimiento-certificados", component: SeguimientoCertificadosComponent },
  { path: "seguimiento-expedientes", component: SeguimientoExpedienteComponent },
  {
    path: "busqueda-direccion",
    loadChildren: () =>
      import("./components/totem/busqueda-dir.module").then(
        (m) => m.BusquedaDirModule
      ),
  },
  // {
  //   path: "seguimiento_expediente",
  //   loadChildren: () =>
  //    import("src/app/components/seguimiento_expediente/seguimiento_expediente.module").then((m) => m.SeguimientoExpedienteModule),
  // },

  // {
  //   path: 'aux/vivienda', 
  //   loadChildren: () =>
  //     import("src/app/components/solicitud-vivienda/solicitud-vivienda.module").then(
  //       (m) => m.SolicitudViviendaModule),
  // },
  // { path: 'solicitud_vivienda', component: SolicitudViviendaComponent },

  // { path: 'solicitud_vivienda', component: SolicitudViviendaComponent },
  { path: 'solicitud_vivienda/:tipo_solicitud', component: SolicitudViviendaComponent },

  { path: 'constancia', component: SolicitudViviendaXNumComponent },
  { path: 'aux/vivienda', component: AuxCertSinPComponent },

  { path: 'aux/documentos', component: auxUrlDocsComponent },
  // AuxCertSinPComponent
  {
    path: "404",
    loadChildren: () =>
      import("./components/404/404.module").then((m) => m.NotFoundPageModule),
  },
  {
    path: "**",
    loadChildren: () =>
      import("./components/404/404.module").then((m) => m.NotFoundPageModule),
  },
];

export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, {
  useHash: true,
});

@NgModule({
  imports: [routing],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }
